'use client';

import React, {useEffect} from "react";
import { ProductXLMouthpieceThumbnails } from "./ProductXLMouthpieceThumbnails";
import { XLMouthpiecesMobileSlider } from "../XLMouthpiecesMobileSlider";
import css from "./product-xl-mouthpieces.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import { XLMouthpieces, thumbnailsDirectory } from "./constants";
import useProductXLMouthpieces from "./useProductXLMouthpieces";
import type { ProductXLMouthpiecesProps } from "./types";
import { Patent } from '@components';

interface ProductXLMouthpieceImageProps {
    mouthpieceComponentProps: any;
    mouthpiecesDirectory: string;
    imageHeight: number;
}

const ProductXLMouthpieceImage = ({ imageHeight, mouthpieceComponentProps, mouthpiecesDirectory }: ProductXLMouthpieceImageProps) => {
    const [isSnaptixOpen, setIsSnaptixOpen] = React.useState<boolean>(false);
    const buttonRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (buttonRef.current) {
            buttonRef.current.addEventListener('mouseenter', () => setIsSnaptixOpen(true));
            buttonRef.current.addEventListener('mouseleave', () => setIsSnaptixOpen(false));
        }
    }, []);

    return (
        <div ref={buttonRef} key={mouthpieceComponentProps.slug}>
            <VadImage
                src={mouthpieceComponentProps.slug.includes('snaptix')
                    ? `${mouthpiecesDirectory}${mouthpieceComponentProps.slug}-${isSnaptixOpen ? 'open' : 'closed'}.2.png`
                    : `${mouthpiecesDirectory}${mouthpieceComponentProps.slug}.png`
                }
                alt={mouthpieceComponentProps.title} width={384}
                height={imageHeight} data-image-gallery-id={mouthpieceComponentProps.slug}
            />
        </div>
    );
}

export const ProductXLMouthpieces = ({ footer, imageHeight, mouthpiecesDirectory, pageContent }: ProductXLMouthpiecesProps): React.FunctionComponentElement<ProductXLMouthpiecesProps> =>
{    
    const { mouthpieceComponentProps, handleSelectMouthpieceThumbnailSlug } = useProductXLMouthpieces();
    const patent = pageContent[`mouthpieces.${mouthpieceComponentProps?.slug}.patent` as 'mouthpieces.patent']?.data
    
    return (
        <div className={css["mouthpieces"]}>
            <div className={`${css["image-pane"]} ${css["fade-in"]}`}>
                {!!mouthpieceComponentProps && (
                    <ProductXLMouthpieceImage
                        imageHeight={imageHeight}
                        mouthpieceComponentProps={mouthpieceComponentProps}
                        mouthpiecesDirectory={mouthpiecesDirectory}
                    />
                )}
                {patent && <Patent patent={patent}/>}
            </div>
            <div className={`${css["thumbnails-pane"]}`}>
                <div className={`${css["display-desktop"]}`}>
                    <ProductXLMouthpieceThumbnails items={XLMouthpieces} thumbnailsDirectory={thumbnailsDirectory} handleSetMouthpieceThumbnail={handleSelectMouthpieceThumbnailSlug} />
                    {footer !== undefined && <div className={css["thumbnails-footnote"]}>{footer}</div>}
                </div>
                <div className={`${css["display-mobile"]} ${css['mouthpieces_mobile_slider_wrapper']}`}>
                    <XLMouthpiecesMobileSlider
                        items={XLMouthpieces}
                        thumbnailsDirectory={thumbnailsDirectory}
                        handleSetMouthpieceThumbnail={handleSelectMouthpieceThumbnailSlug}
                        selectedItemTitle={mouthpieceComponentProps?.title ?? ""}
                    />
                </div>
            </div>
        </div>
    );
};